import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core'

@Injectable()
export class LangService {
  selected:any='en';


  constructor(private translate: TranslateService){
  //   if(localStorage.getItem('lang')){
  //   this.selected = localStorage.getItem('lang');
  //   this.translate.setDefaultLang(this.selected);
  // }
}

}



// WEBPACK FOOTER //
// ./src/app/lang.service.ts